<template>
    <div class="calendar-date-picker">
        <h3 class="calendar-date-picker__month-title">{{ format(month, 'MMMM yyyy') }}</h3>
        <table class="calendar-date-picker__table">
            <thead>
            <tr>
                <th v-for="day in weekDays" :key="day">{{ day }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="week in weeks" :key="week[0].toISOString()">
                <td v-for="day in week" :key="day.toISOString()" :class="getCellClasses(day)">
                    <button
                        v-if="isCurrentMonth(day) && hasEvent(day)"
                        @click="emit('select-date', day)"
                        :aria-label="format(day, 'MMMM d, yyyy')"
                        class="calendar-date-picker__date-button"
                    >
                        {{ day.getDate() }}
                    </button>
                    <span v-else class="month-calendar__day-text">
                            {{ day.getDate() }}
                        </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import { format, startOfMonth, endOfMonth, eachDayOfInterval, startOfWeek, endOfWeek } from 'date-fns';
import { computed } from 'vue';

const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const props = defineProps({
    month: {
        type: Date,
        required: true,
    },
    eventsByDate: {
        type: Object,
        required: true,
    },
    showDate: {
        type: Boolean,
        required: false,
    }
});

const emit = defineEmits(['select-date']);

const weeks = computed(() => {
    const start = startOfWeek(startOfMonth(props.month));
    const end = endOfWeek(endOfMonth(props.month));
    const days = eachDayOfInterval({ start, end });

    const weeksList = [];
    for (let i = 0; i < days.length; i += 7) {
        weeksList.push(days.slice(i, i + 7));
    }
    return weeksList;
});

const isCurrentMonth = (day) => {
    return day.getMonth() === props.month.getMonth();
};

const hasEvent = (day) => {
    const dateKey = format(day, 'yyyy-MM-dd');
    return !!props.eventsByDate[dateKey];
};

const getCellClasses = (day) => ({
    'calendar-date-picker__date-cell': true,
    'month-calendar__other-month-cell': !isCurrentMonth(day),
});
</script>
